import { rem } from 'polished'
import styled from 'styled-components'
import { AccommodationRoomTileImageContainer } from '../AccommodationRoomTileImage'
import type { PropsWithChildren } from 'react'
import React from 'react'
import clsx from 'clsx'
import { StyledAccommodationSameRoomTileDetails } from './AccommodationSameRoomTileDetails'
import { AccommodationSameRoomTileGridBase } from './AccommodationSameRoomTileGridBase'
import { mapRoomPackage } from '../roomPackageUtils'
import { mediaQueryOnly, mediaQueryUp } from 'components/utils/breakpoint'

const AccommodationSameRoomTileGrid = styled(AccommodationSameRoomTileGridBase)`
  position: relative;
  display: grid;

  &.hasImage {
    grid-template:
      "image" ${rem(210)}
      "details" auto
      "options" auto / 1fr;

    ${mediaQueryUp.tablet} {
    grid-template:
      "image" ${rem(320)}
      "details" auto
      "options" auto / 1fr;
    }

    ${mediaQueryUp.desktop} {
      grid-template:
        "image details" auto
        "options options" auto;
      &.image-size-medium {
        grid-template-columns: ${rem(400)} 1fr;
      }
      &.image-size-small {
        grid-template-columns: ${rem(300)} 1fr;
      }
    }
  }

  &:not(.hasImage) {
    grid-template:
      "details" auto
      "options" auto / 1fr;

    > ${AccommodationRoomTileImageContainer} {
      display: none;
    }
  }

  &.hasImage > ${StyledAccommodationSameRoomTileDetails} {
    ${mediaQueryOnly.tablet} {
      border-top: 0;
    }

    ${mediaQueryUp.desktop} {
      border-left: 0;
    }
  }
`
interface Props extends PropsWithChildren {
  roomPackage: App.HotelPackage | App.BedbankPackage | App.Property.Room
  imageSize?: 'small' | 'medium'
}

function AccommodationSameRoomTile(props: Props) {
  const { roomPackage, imageSize = 'medium', children } = props

  const images = mapRoomPackage(
    roomPackage,
    propertyRoom => propertyRoom.images,
    hotelPkg => hotelPkg.roomType.images,
    bedbankPkg => bedbankPkg.images,
  )

  return <AccommodationSameRoomTileGrid
    background="neutral-eight"
    className={clsx({ hasImage: !!images?.length }, `image-size-${imageSize}`)}
  >
    {children}
  </AccommodationSameRoomTileGrid>
}

export default AccommodationSameRoomTile
